import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetMessageThreadsQuery } from "src/api/services/messagesApi";
import { useUpdateVisitMutation } from "src/api/services/visitApi";
import { Paths } from "src/constants/paths";
import { useVisit } from "src/context/VisitProvider";

export const useCompleteVisit = () => {
  const visitId = useVisit((v) => v.slug);
  const completed = useVisit((v) => v.completed_at != null);
  const productId = useVisit((v) => v.product.slug);
  const [updateVisit] = useUpdateVisitMutation();
  const navigate = useNavigate();
  const { data: threads } = useGetMessageThreadsQuery();

  const handleGoToMessages = useCallback(() => {
    const thread = threads?.find((th) => th.product.slug === productId);

    if (thread == null) {
      navigate(Paths.MY_ACCOUNT + "/" + Paths.MY_ACCOUNT_OVERVIEW);
    } else {
      navigate(Paths.MESSAGING + "/" + thread.slug);
    }
  }, [navigate, productId, threads]);

  const handleGoToPortal = useCallback(() => {
    navigate(Paths.MY_ACCOUNT + "/" + Paths.MY_ACCOUNT_OVERVIEW);
  }, [navigate]);

  useEffect(() => {
    if (completed === true) return;
    updateVisit({
      slug: visitId,
      data: {
        status: "completed",
        completed_at: new Date().toISOString(),
      },
    });
  }, [completed, updateVisit, visitId]);

  return { handleGoToMessages, handleGoToPortal };
};
